import React from 'react';
import { ThresholdType } from 'commons/src/models/commonEnums';
import styles from './ThresholdDot.module.scss';

/** Gradient transition for the dot: green→yellow (Good→Fair) or yellow→red (Fair→Poor), or for 4-threshold rows; blue/red for temperature */
export type DotGradientVariant =
    | 'greenToYellow'
    | 'yellowToRed'
    | 'redToYellow'
    | 'yellowToGreen'
    | 'green'
    | 'yellow'
    | 'red'
    | 'blue';

type Props = {
    type: ThresholdType;
    /** When set, overrides type-based color. Use gradient variants for transition dots (e.g. greenToYellow, yellowToRed). */
    variant?: DotGradientVariant;
};

const ThresholdDot = ({ type, variant }: Props): React.ReactElement => {
    let className = styles.dotColorYellow;
    if (variant === 'greenToYellow') className = styles.dotGradientGreenYellow;
    else if (variant === 'yellowToRed') className = styles.dotGradientYellowRed;
    else if (variant === 'redToYellow') className = styles.dotGradientRedYellow;
    else if (variant === 'yellowToGreen') className = styles.dotGradientYellowGreen;
    else if (variant === 'green') className = styles.dotColorGreen;
    else if (variant === 'red') className = styles.dotColorRed;
    else if (variant === 'blue') className = styles.dotColorBlue;
    else if (!variant) {
        const isRed = [ThresholdType.LOW_ALERT, ThresholdType.HIGH_ALERT].includes(type);
        className = isRed ? styles.dotColorRed : styles.dotColorYellow;
    }

    return <span className={className} />;
};

export default ThresholdDot;
